module.exports = __webpack_public_path__ + "img/65.a4c037d9.jpg";